module.exports = "/packs/_/assets/images/flags/flag-us-159701416d56a0a505555a5ed1c4edd8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/flags/flag-us.svg
// module id = 1770
// module chunks = 0